import { IconMerchant } from '@hubble/icons';
import { useState } from 'react';
import { IconBadge } from '../IconBadge/index.js';
import { MX_URL } from '../shared/constants.js';
import { StyledImg } from '../shared/styles.js';
import { jsx } from '@emotion/react/jsx-runtime';

const MerchantIcon = ({
  size = 'lg',
  merchant
}) => {
  const src = `${MX_URL}/${merchant}.png`;
  const [imgLoadError, setImgLoadError] = useState(false);
  if (imgLoadError) return jsx(IconBadge, {
    icon: jsx(IconMerchant, {}),
    size: size
  });
  return jsx(StyledImg, {
    src: src,
    alt: merchant,
    onError: () => setImgLoadError(true),
    size: size,
    border: true
  });
};
MerchantIcon.displayName = 'MerchantIcon';

export { MerchantIcon };
